/**
 * Traducción de la rareza numérica de una carta (1-5 estrellas) a su
 * categoría visual (común/rara/épica) y color de marco. Lógica pura sin
 * Phaser: los colores son números hex que `ui/shop/ShopView` usa para teñir
 * el marco de cada carta.
 */

import type { CardDef } from '../core/types';

export type RarityTier = 'comun' | 'rara' | 'epica';

/**
 * Mapea las estrellas (1-5) de una carta a su categoría:
 * 1 estrella = común (gris), 2-3 = rara (azul), 4-5 = épica (dorada).
 */
export function rarityTier(rarity: CardDef['rarity']): RarityTier {
  if (rarity <= 1) return 'comun';
  if (rarity <= 3) return 'rara';
  return 'epica';
}

/** Color de marco (hex) por categoría, según la spec (gris/azul/dorado). */
export const RARITY_FRAME_COLOR: Record<RarityTier, number> = {
  comun: 0x8a8a99,
  rara: 0x3fa0e8,
  epica: 0xf2b93d,
};

/** Nombre en español neutro de cada categoría, para mostrar en la UI. */
export const RARITY_LABEL: Record<RarityTier, string> = {
  comun: 'Común',
  rara: 'Rara',
  epica: 'Épica',
};

/** Cadena de estrellas ("★★★") para renderizar la rareza de una carta. */
export function rarityStars(rarity: CardDef['rarity']): string {
  return '★'.repeat(rarity);
}
